<template>
  <div class="ly-table">
    <div class="ly-title">
      <h3 class="title-table">
        <slot></slot>
      </h3>
      <div class="table-toggle" v-if="toggle === true">
        <i class="el-icon-arrow-up" @click="clickToggle"></i>
      </div>
    </div>
    <div ref="content" v-if="!$isMobile()">
      <div class="content-detail">
        <div class="ctrt-header">
          <span class="count">
            {{ $t("messages.titTblSaftyEduEvidenceData") }}
          </span>
          <el-button size="small" type="plus"
            ><i class="icon-Plus"
          /></el-button>
        </div>
        <idc-list :tableHeader="tableHeader1" :tableData="tableData1">
          <template #col1="{ scope }">
            <div class="border-box ctrt-upload">
              <idc-file-upload
                action=""
                :file-list="fileList"
                :on-exceed="handleExceed"
              >
              </idc-file-upload>
            </div>
          </template>
          <template #col2="{ scope }">
            <el-button type="minus">
              <i class="icon-Minus" />
            </el-button>
          </template>
        </idc-list>
      </div>
      <div class="content-detail">
        <div class="ctrt-header">
          <span class="count"> {{ $t("messages.titTblEntryList") }} </span>
          <el-button size="small" type="plus"
            ><i class="icon-Plus"
          /></el-button>
        </div>
        <idc-list :tableHeader="tableHeader" :tableData="tableData">
          <template #col2="{ scope }">
            <el-select
              size="mini"
              v-model="scope.row.col2"
              :placeholder="$t('messages.plSelectOp')"
            >
              <el-option
                v-for="item in countList1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #col3="{ scope }">
            <el-date-picker
              v-model="scope.row.col3"
              size="mini"
              type="date"
              align="right"
              placeholder="YYYY/MM/DD"
            />
          </template>
          <template #col4="{ scope }">
            <el-select
              size="mini"
              v-model="scope.row.col4"
              :placeholder="$t('messages.plSelectOp')"
            >
              <el-option
                v-for="item in countList2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #col5="{ scope }">
            <el-select
              size="mini"
              v-model="scope.row.col5"
              :placeholder="$t('messages.plSelectOp')"
            >
              <el-option
                v-for="item in countList3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #col6="{ scope }">
            <el-select
              size="mini"
              v-model="scope.row.col6"
              :placeholder="$t('messages.plSelectOp')"
            >
              <el-option
                v-for="item in countList4"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #col10="{ scope }">
            <el-select
              size="mini"
              v-model="scope.row.col10"
              :placeholder="$t('messages.plSelectOp')"
            >
              <el-option
                v-for="item in countList4"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #col11="{ scope }">
            <el-select
              size="mini"
              v-model="scope.row.col11"
              :placeholder="$t('messages.plSelectOp')"
            >
              <el-option
                v-for="item in countList4"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #col12="{ scope }">
            <el-button type="minus" size="mini">
              <i class="icon-Minus" />
            </el-button>
          </template>
        </idc-list>
        <div class="btn-box">
          <el-button plain type="primary">
            {{ $t("messages.btnRequestVisitReserve") }}</el-button
          >
          <el-button type="primary">{{ $t("messages.btnSave") }}</el-button>
        </div>
      </div>
    </div>
    <div ref="content" v-else>
      <div class="content-detail">
        <idc-list :tableHeader="mobTableHeader" :tableData="mobTableData" />
      </div>
    </div>
  </div>
</template>
<script>
import IdcFileUpload from "@/components/common/IdcFileUpload.vue";
import IdcList from "@/components/common/IdcList.vue";
export default {
  components: {
    IdcFileUpload,
    IdcList,
  },
  props: {
    openToggle: {
      value: Boolean,
      dafault: false,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    isWrite: {
      type: Boolean,
      default: true,
    },
    isTemplate: {
      type: Boolean,
      default: true,
    },
    assetTypeCd: {
      type: String,
      default: "",
    },
    prcssTrtDataCnctId: {
      type: String,
      default: "",
    },
    exeWflowId: {
      type: String,
      default: "",
    },
    idcCd: {
      type: String,
      default: "",
    },
    ticketInfo: {
      type: Object,
      default: () => {},
    },
    //상위 공정 ID
    mainPrcssId: {
      type: String,
      default: "",
    },
    //하위 공정 ID
    subPrcssId: {
      type: String,
      default: "",
    },
    scrnId: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: "",
    },
    scrnGetApi: {
      type: String,
      default: "",
    },
    scrnPostApi: {
      type: String,
      default: "",
    },
    scrnPutApi: {
      type: String,
      default: "",
    },
    scrnDeleteApi: {
      type: String,
      default: "",
    },
    mandDataChkYn: {
      type: String,
      default: "N",
    },
    sftyChkMandChkYn: {
      type: String,
      default: "N",
    },
    sftyChkScrnYn: {
      type: String,
      default: "N",
    },
    callDate: {
      type: Number,
      default: -1,
    },
    stepCd: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      date: null,
      count1: 1,
      count2: 2,
      count3: 3,
      count4: 4,
      count5: 4,
      count6: 4,
      countList1: [
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
      ],
      countList2: [
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
      ],
      countList3: [
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
      ],
      countList4: [
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
      ],
      countList5: [
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
      ],
      countList6: [
        {
          value: 1,
          label: "1",
        },
        {
          value: 2,
          label: "2",
        },
        {
          value: 3,
          label: "3",
        },
      ],
      toggleData: true,
      toggle: this.openToggle,
      fileList: [
        {
          name: "food.jpeg",
          url: "",
        },
      ],

      tableHeader: [
        {
          type: "selection",
          align: "left",
        },
        {
          prop: "col1",
          label: "NO",
          width: "5",
        },
        {
          prop: "col2",
          label: "방문DC",
          columnType: "custom",
          width: "8",
        },
        {
          prop: "col3",
          label: "방문예약일",
          columnType: "custom",
          width: "14",
        },
        {
          prop: "col4",
          label: "층구분",
          columnType: "custom",
          width: "7",
        },
        {
          prop: "col5",
          label: "방문층",
          columnType: "custom",
          width: "7",
        },
        {
          prop: "col6",
          label: "방문룸",
          columnType: "custom",
          width: "7",
        },
        {
          prop: "col7",
          label: "방문자",
          width: "7",
        },
        {
          prop: "col8",
          label: "소속사",
          width: "7",
        },
        {
          prop: "col9",
          label: "휴대전화",
          width: "10",
        },
        {
          prop: "col10",
          label: "방문목적",
          columnType: "custom",
          width: "10",
        },
        {
          prop: "col11",
          label: "고객사",
          columnType: "custom",
          width: "10",
        },
        {
          prop: "col12",
          label: "",
          columnType: "custom",
          width: "4",
        },
      ],

      tableData: [
        {
          col1: 1,
          col2: null,
          col3: null,
          col4: null,
          col5: null,
          col6: null,
          col7: "홍길동",
          col8: "ktds",
          col9: "010-1234-5678",
          col10: null,
          col11: null,
        },
        {
          col1: 2,
          col2: null,
          col3: null,
          col4: null,
          col5: null,
          col6: null,
          col7: "홍길동",
          col8: "ktds",
          col9: "010-1234-5678",
          col10: null,
          col11: null,
        },
      ],
      mobTableHeader: [
        {
          prop: "col1",
          label: "DC",
        },
        {
          prop: "col2",
          label: "방문자",
        },
        {
          prop: "col3",
          label: "고객사",
        },
        {
          prop: "col4",
          label: "층구분",
        },
        {
          prop: "col5",
          label: "소속사",
        },
        {
          prop: "col6",
          label: "예약일",
        },
        {
          prop: "col7",
          label: "방문자",
        },
        {
          prop: "col8",
          label: "휴대전화",
        },
      ],
      mobTableData: [
        {
          col1: "목동1센터",
          col2: "홍길동",
          col3: "(주)AAA",
          col4: "지상",
          col5: "KTDS",
          col6: "20220123",
          col7: "1층/A룸",
          col8: "010-1111-2222",
        },
        {
          col1: "목동1센터",
          col2: "홍길동",
          col3: "(주)AAA",
          col4: "지상",
          col5: "KTDS",
          col6: "20220123",
          col7: "1층/A룸",
          col8: "010-1111-2222",
        },
        {
          col1: "목동1센터",
          col2: "홍길동",
          col3: "(주)AAA",
          col4: "지상",
          col5: "KTDS",
          col6: "20220123",
          col7: "1층/A룸",
          col8: "010-1111-2222",
        },
      ],
      tableHeader1: [
        {
          type: "selection",
          align: "left",
        },
        {
          prop: "col1",
          label: "파일명",
          columnType: "custom",
          width: "18",
        },
        {
          prop: "col2",
          label: "",
          columnType: "custom",
          width: "1",
        },
      ],
      tableData1: [
        {
          col1: null,
          col2: null,
        },
        {
          col1: null,
          col2: null,
        },
      ],
    };
  },
  methods: {
    chkValidateData() {
		// 공정처리데이터아이디가 있으면 true
		// 단, 목록성 데이터인 경우 로우가 있어야지 true(Skip 버튼은 예외)
      if(this.mandDataChkYn != 'Y'){
        return true;
      }
      if(this.prcssTrtDataCnctId != null && this.prcssTrtDataCnctId != ''){
        return true;
      }else{
        return false;
      }
    },
    getTemplateData() {
      // 상위 컴포넌트에서 호출
      // Axios로 저장 시 넘겨줄 데이터를 리턴하면 됨.
      return "";
    },
    clickToggle(e) {
      if (this.toggleData) {
        this.$refs.content.style = "display: none";
        e.target.className = "el-icon-arrow-down";
      } else {
        this.$refs.content.style = "display: block;";
        e.target.className = "el-icon-arrow-up";
      }
      this.toggleData = this.toggleData ? false : true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `The limit is 3, you selected ${
          files.length
        } files this time, add up to ${files.length + fileList.length} totally`
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-box {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.border-box {
  padding: 5px 5px;
  display: flex;
  justify-content: space-between;
}
.ctrt-header {
  padding: 5px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ly {
  &-upload {
    width: 100%;
  }
}
.content-detail:nth-child(2) {
  margin-top: 20px;
}

.ctrt-upload {
  width: 100%;
}
</style>
